import { useCustomSWR } from 'utils/hooks/fetchers'

export const useGuessLikesByArticle = (articleId) => {
  const genUrl = () => (articleId ? `/articles/${articleId}/guessLike` : null)
  return useCustomSWR(genUrl)
}
